import http from '@/http';

const ItemAgropecuarioService = {
  async getLkpItemAgropecuario(tipoProjeto, safraEpoca) {
    const dataItemAgropecuario = await http.get(`/api/astec/getLkpItemAgropecuario/${tipoProjeto}/${safraEpoca}`);
    return dataItemAgropecuario.data.map((item) => ({
      name: item.DISPLAY,
      value: item.ID,
    }));
  }
};
export default ItemAgropecuarioService;
